const CN_SIFT_SCIENCE_COOKIE = 'cn_sift_science';
export default CN_SIFT_SCIENCE_COOKIE;
